<template>
<div v-if="false"></div>
</template>

<script>
import { LINE_PATH_CONFIG } from './settings/mapSettings'
import GmapsCubicBezier from './GmapsCubicBezier'

export default {
  props: {
    google: {
      type: Object,
      required: true
    },
    map: {
      type: Object,
      required: true
    },
    path: {
      type: Array,
      required: true
    }
  },

  mounted () {
    this.drawCurve(this.path, this.google, this.map, LINE_PATH_CONFIG)
  },

  methods: {
    drawCurve (path, google, map, config) {
      const CURVE = 1.5
      const P1 = new google.maps.LatLng(path[0])
      const P2 = new google.maps.LatLng(path[1])

      const lineLength = google.maps.geometry.spherical.computeDistanceBetween(P1, P2)
      const lineHeading = google.maps.geometry.spherical.computeHeading(P1, P2)

      let lineHeading1 = null
      let lineHeading2 = null

      if (lineHeading > 0) {
        lineHeading1 = lineHeading - 45
        lineHeading2 = lineHeading + 135
      } else {
        lineHeading1 = lineHeading + 45
        lineHeading2 = lineHeading - 135
      }

      const pA = google.maps.geometry.spherical.computeOffset(P1, lineLength / CURVE, lineHeading1)
      const pB = google.maps.geometry.spherical.computeOffset(P2, lineLength / CURVE, lineHeading2)

      // eslint-disable-next-line
      const curvedLine = new GmapsCubicBezier(P1, pA, pB, P2, 0.1, google, map, config)
    }
  }
}
</script>
